<script setup lang="ts">

import type NewsItem from "@/types/NewsItem.ts";
import NewsItemBaseStructure from '@/components/Sections/News/Types/Base/NewsItemBaseStructure.vue'
import NewsItemBase from '@/components/Sections/News/Types/Base/NewsItemBase.vue'
import PlayerName from '@/components/Objects/PlayerName.vue'
import { usePlayerRelationStore } from '@/stores/playerRelations.ts'
import { useGameStore } from '@/stores/gameStore.ts'
import { computed } from 'vue'

const playerRelationStore = usePlayerRelationStore();
const gameStore = useGameStore();

/**
 * Props
 */
const props = defineProps<{
  newsItem: NewsItem,
  toast: boolean
}>();

/**
 * Computed
 */
const playerImage = computed(() => {
  return playerRelationStore.getProfileImageByPlayerId(props.newsItem.contentData.playerId);
});

</script>

<template>
  <NewsItemBase
    :toast="toast"
    :toast-image="playerImage"
    :toast-text="'Enemy spy caught!'"
  >
    <NewsItemBaseStructure
      :newsItem="props.newsItem"
      :item-image="playerImage"
      :header="'Enemy spy caught!'"
    >
      A spy from <PlayerName :player-id="props.newsItem.contentData.playerId" /> was apprehended during a {{ props.newsItem.contentData.missionName }} mission against you. Thanks to your counter-espionage team, the spy was successfully neutralized.
      <span v-if="gameStore.combatMode === 'RC'" class="text-red-500 block mt-2">
        Note: The player that was caught no longer has protection against you.
      </span>
    </NewsItemBaseStructure>
  </NewsItemBase>
</template>

<style scoped lang="scss">

</style>